import { render } from "./Relation.vue?vue&type=template&id=53a679fc&scoped=true"
import script from "./Relation.vue?vue&type=script&lang=js"
export * from "./Relation.vue?vue&type=script&lang=js"

import "./Relation.vue?vue&type=style&index=0&id=53a679fc&lang=scss&scoped=true"

import exportComponent from "E:\\Workspaces\\website-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a679fc"]])

export default __exports__